var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningAmber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.57169L22.785 22.75H5.21496L14 7.57169ZM14 2.91669L1.16663 25.0834H26.8333L14 2.91669ZM15.1666 19.25H12.8333V21.5834H15.1666V19.25ZM15.1666 12.25H12.8333V16.9167H15.1666V12.25Z",
    fill: "#E3382D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAmber);
export default __webpack_public_path__ + "static/media/warning_amber.6807aac694e0fb1b7c6212acc570ec95.svg";
export { ForwardRef as ReactComponent };